import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Briefcase, MapPin, Clock, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const CareersPage = () => {
  const openings = [
    {
      id: 1,
      title: 'Senior Data Engineer',
      department: 'Data & AI',
      location: 'Chantilly, VA',
      type: 'Full-time',
      description: 'Join our Data & AI team to design and implement scalable data solutions for enterprise clients.',
    },
    {
      id: 2,
      title: 'Cloud Solutions Architect',
      department: 'Cloud Services',
      location: 'Remote',
      type: 'Full-time',
      description: 'Lead cloud transformation initiatives and design robust cloud architectures for our clients.',
    },
    {
      id: 3,
      title: 'Cybersecurity Analyst',
      department: 'Security',
      location: 'Chantilly, VA',
      type: 'Full-time',
      description: 'Protect our clients digital assets by implementing and monitoring security solutions.',
    },
    {
      id: 4,
      title: 'Project Manager',
      department: 'PMO',
      location: 'Hybrid',
      type: 'Full-time',
      description: 'Drive successful project delivery for federal and commercial clients.',
    },
  ];

  const benefits = [
    'Competitive Salary & Bonuses',
    'Health, Dental & Vision Insurance',
    'Flexible Work Arrangements',
    'Professional Development',
    '401(k) with Company Match',
    'Paid Time Off & Holidays',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-100 via-orange-50 to-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-0.5 bg-orange-500" />
              <span className="text-gray-600 font-medium tracking-wide">Careers</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
              Join Our Team
            </h1>
            <p className="text-gray-700 text-lg leading-relaxed">
              Build your career with a team that values innovation, growth, and making a real impact. We're looking for talented individuals to help shape the future of technology.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-12 text-center">Why Work With Us?</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="p-6 bg-gradient-to-br from-slate-50 to-white border border-gray-100 rounded-xl text-center hover:shadow-lg transition-shadow"
              >
                <p className="text-gray-700 font-medium">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-12">Open Positions</h2>
          <div className="space-y-6">
            {openings.map((job) => (
              <div
                key={job.id}
                className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-slate-900 mb-2">{job.title}</h3>
                    <p className="text-gray-600 mb-4">{job.description}</p>
                    <div className="flex flex-wrap gap-4">
                      <span className="flex items-center text-sm text-gray-500">
                        <Briefcase className="w-4 h-4 mr-2 text-orange-500" />
                        {job.department}
                      </span>
                      <span className="flex items-center text-sm text-gray-500">
                        <MapPin className="w-4 h-4 mr-2 text-orange-500" />
                        {job.location}
                      </span>
                      <span className="flex items-center text-sm text-gray-500">
                        <Clock className="w-4 h-4 mr-2 text-orange-500" />
                        {job.type}
                      </span>
                    </div>
                  </div>
                  <div className="mt-6 md:mt-0">
                    <Button
                      className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full flex items-center"
                    >
                      Apply Now
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CareersPage;
